export enum EAIReminderTiming {
  nothing = "0",
  oneday = "24",
  twodays = "48",
  oneweek = "168",
  twoweeks = "360",
  onemonth = "720"
}

export const aiReminderTimingAsString = (aiReminderTiming: EAIReminderTiming): string => {
  switch (aiReminderTiming) {
    case EAIReminderTiming.nothing:
      return "Pas de relance";
    case EAIReminderTiming.oneday:
      return "24 heures";
    case EAIReminderTiming.twodays:
      return "48 heures";
    case EAIReminderTiming.oneweek:
      return "1 semaine";
    case EAIReminderTiming.twoweeks:
      return "2 semaines";
    case EAIReminderTiming.onemonth:
      return "1 mois";
    default:
      return "";
  }
};
